const toggleMap = {
    btn: document.getElementById('toggleMap') as HTMLElement,
    header: document.getElementById('header') as HTMLElement,
    navSearch: document.getElementById('navSearch') as HTMLElement,
    cols: document.querySelectorAll(".jsCategoryCol") as NodeListOf<HTMLElement>,


    init() {
        this.toggleMap();
    },

    toggleMap() {
        this.btn?.addEventListener('click', () => {
            document.body.classList.toggle('map-opend');
            this.header.classList.toggle('top');
            this.navSearch.classList.toggle('top');
            this.cols.forEach(item => item.classList.toggle('active'))
            this.btn.firstElementChild?.classList.toggle('d-none');
            this.btn.lastElementChild?.classList.toggle('d-none');
        })

    },


}

export default toggleMap;